import { render, staticRenderFns } from "./PFullCardListItem.vue?vue&type=template&id=2be0eab6&scoped=true&"
import script from "./PFullCardListItem.vue?vue&type=script&lang=ts&"
export * from "./PFullCardListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PFullCardListItem.vue?vue&type=style&index=0&id=2be0eab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0eab6",
  null
  
)

export default component.exports